import React from "react";

const Footer = () => {
    return (
        <div class="copyright">
            <p>Copyright @Chigowdev. 2024</p>
        </div>
    );
}
export default Footer;